module.exports = __webpack_public_path__ + "img/FishingShip64_ua.2eb6b1d2.webp";